import { createContext, useContext } from "react";

export const GridPreviewContext = createContext(false);

export const useGridPreview = () => useContext(GridPreviewContext);
